import { Bar, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { euro } from "@/lib/accounting";
import { MONTHS_IT } from "@/components/control/CompareTab";

const KEYS = ["budget_revenue", "budget_cost", "revenue", "cost"];
const short = (v) => (Math.abs(v) >= 1000 ? `${(v / 1000).toLocaleString("it-IT", { maximumFractionDigits: 0 })}k` : v.toLocaleString("it-IT"));

export const TrendChart = ({ rows, title, upto = 12 }) => {
  const data = MONTHS_IT.map((m, i) => {
    const d = { name: m };
    KEYS.forEach((k) => { d[k] = rows.reduce((s, r) => s + r.months[i][k], 0); });
    d.margin = i < upto ? d.revenue - d.cost : null;
    return d;
  });
  return (
    <div className="mb-4 border bg-white p-4" data-testid="trend-chart">
      <div className="micro-label mb-2">Andamento mensile · {title}</div>
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" vertical={false} />
            <XAxis dataKey="name" tick={{ fontSize: 11 }} />
            <YAxis tickFormatter={short} tick={{ fontSize: 11 }} width={48} />
            <Tooltip formatter={(v) => (v == null ? "—" : euro(v))} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="revenue" name="Ricavi" fill="hsl(var(--primary))" maxBarSize={22} />
            <Bar dataKey="cost" name="Costi" fill="#64748B" maxBarSize={22} />
            <Line dataKey="budget_revenue" name="Budget ricavi" stroke="hsl(var(--primary))" strokeDasharray="6 4" dot={false} strokeWidth={2} />
            <Line dataKey="budget_cost" name="Budget costi" stroke="#475569" strokeDasharray="6 4" dot={false} strokeWidth={2} />
            <Line dataKey="margin" name="Margine" stroke="#059669" strokeWidth={2.5} dot={{ r: 3 }} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
